<template>
  <div class="h-full overflow-y-auto overflow-x-hidden">
    <el-form
      ref="form"
      label-width="120px"
      class="editWrapAd"
      :model="adsMsg"
      :rules="rules"
      :disabled="currentData.disabled"
      @submit.native.prevent
    >
      <el-form-item
        label="广告名称"
        prop="name"
      >
        <el-input
          v-model="adsMsg.name"
          placeholder="广告名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="广告状态"
        prop="status"
      >
        <el-switch
          v-model="adsMsg.status"
          active-text="开启"
          inactive-text="暂停"
          active-value="ENABLED"
          inactive-value="PAUSED"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <AdCreative
      ref="adCreative"
      v-model="adsMsg.searchAd"
      :disabled="currentData.disabled"
      :keywordList="adsMsg.keywordList"
      :enumConstants="enumConstants"
      :createAdAccount="createAdAccount"
    />
  </div>
</template>
<script>
import AdCreative from '@/views/google/createSearchAds/components/AdCreative';
import { mapState } from 'vuex';
const baseRules = {
  name: [
    {
      required: true,
      message: '广告名称必填',
    },
  ],
  status: [{ required: true }],
};
export default {
  props: {
    currentData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      adsMsg: {
        demandGenAd: {},
      },
      enumConstants: {},
    };
  },
  components: {
    AdCreative,
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
    rules() {
      return { ...baseRules };
    },
  },
  watch: {
    currentData: {
      handler() {
        this.adsMsg = this.currentData;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /**校验广告 */
    async checkForm() {
      console.log(this.$refs.adCreative.validate());
      try {
        console.log(this.$refs.form.validate(), this.$refs.adCreative.validate());
        const [mainFormValid, adCreativeForm] = await Promise.all([
          this.$refs.form.validate(),
          this.$refs.adCreative.validate(),
        ]);
        console.log(mainFormValid, adCreativeForm);
        return mainFormValid && adCreativeForm;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    // 设置广告内容
    getCreativeValue(value, key) {
      this.$set(this.adsMsg.demandGenAd, key, value);
    },
  },
};
</script>
<style lang="scss">
.editWrapAd .titleWrap .el-input {
  width: 90%;
}
</style>
